import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";

export default function Header() {
  const [mobileNavActive, setMobileNavActive] = useState(false);

  // Toggle mobile navigation
  const toggleMobileNav = () => {
    setMobileNavActive(!mobileNavActive);
  };

  // Close mobile nav when clicking on links
  const closeMobileNav = () => {
    setMobileNavActive(false);
  };

  // Handle scroll effect
  useEffect(() => {
    const toggleScrolled = () => {
      const selectBody = document.querySelector('body');
      const selectHeader = document.querySelector('#header');
      
      if (!selectHeader || (!selectHeader.classList.contains('scroll-up-sticky') && 
          !selectHeader.classList.contains('sticky-top') && 
          !selectHeader.classList.contains('fixed-top'))) {
        return;
      }
      
      window.scrollY > 100 ? selectBody.classList.add('scrolled') : selectBody.classList.remove('scrolled');
    };

    document.addEventListener('scroll', toggleScrolled);
    window.addEventListener('load', toggleScrolled);

    return () => {
      document.removeEventListener('scroll', toggleScrolled);
      window.removeEventListener('load', toggleScrolled);
    };
  }, []);

  // Add/remove mobile-nav-active class to body
  useEffect(() => {
    if (mobileNavActive) {
      document.body.classList.add('mobile-nav-active');
    } else {
      document.body.classList.remove('mobile-nav-active');
    }
  }, [mobileNavActive]);

  return (
    <header id="header" className="header d-flex align-items-center light-background sticky-top">
      <div className="container position-relative d-flex align-items-center justify-content-between">
        <NavLink to="/" className="logo d-flex align-items-center me-auto me-xl-0" onClick={closeMobileNav}>
          <h1 className="sitename">Francis Bahati</h1> 
        </NavLink> 

        <nav id="navmenu" className={`navmenu ${mobileNavActive ? 'mobile-nav-active' : ''}`}>
          <ul>
            <li>
              <NavLink 
                to="/" 
                className={({ isActive }) => isActive ? 'active' : ''} 
                onClick={closeMobileNav}
                end
              >
                Home
              </NavLink>
            </li>
            <li>
              <NavLink 
                to="/about" 
                className={({ isActive }) => isActive ? 'active' : ''} 
                onClick={closeMobileNav}
              >
                About
              </NavLink>
            </li>
            <li>
              <NavLink 
                to="/resume" 
                className={({ isActive }) => isActive ? 'active' : ''} 
                onClick={closeMobileNav}
              >
                Resume
              </NavLink>
            </li>
            <li>
              <NavLink 
                to="/services" 
                className={({ isActive }) => isActive ? 'active' : ''} 
                onClick={closeMobileNav}
              >
                Services
              </NavLink>
            </li>
            <li>
              <NavLink 
                to="/portfolio" 
                className={({ isActive }) => isActive ? 'active' : ''} 
                onClick={closeMobileNav}
              >
                Portfolio
              </NavLink>
            </li>
            <li>
              <NavLink 
                to="/contact" 
                className={({ isActive }) => isActive ? 'active' : ''} 
                onClick={closeMobileNav}
              >
                Contact
              </NavLink>
            </li>
          </ul>
          <i 
            className={`mobile-nav-toggle d-xl-none bi ${mobileNavActive ? 'bi-x' : 'bi-list'}`}
            onClick={toggleMobileNav}
          ></i>
        </nav>
      </div>
    </header>
  );
}